import { Component, inject } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import {
  DialogService,
  IconComponent,
  LoadingComponent,
} from '@gains-com/ui-angular';
import { MatButton, MatFabButton } from '@angular/material/button';
import { ShellService } from '../shell.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserViewService } from '../../core/view-states/user-view.service';
import { WalletDialogService } from '../../core/wallet-dialog.service';
import { MerchDialogService } from '../../core/merch-dialog.service';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { AuthComponent, AuthDialogData } from '../../auth/auth.component';
import { DialogKey } from '../../shared/dialog-keys';
import { AsyncPipe } from '@angular/common';
import { EnvironmentPipe } from '../../pipes/environment.pipe';
import { AppRouterService } from '../../core/app-router.service';
import { map } from 'rxjs';
import { PromotionsView } from '../../core/view-states/promotions-view.service';
import { MerchViewService } from '../../core/view-states/merch-view.service';
import { AuthClickDirective } from '../../directives/auth-click.directive';

@Component({
  selector: 'app-bottom-toolbar',
  imports: [
    MatToolbar,
    IconComponent,
    RouterLink,
    MatButton,
    AsyncPipe,
    LoadingComponent,
    EnvironmentPipe,
    MatFabButton,
    AuthClickDirective,
  ],
  templateUrl: './bottom-toolbar.component.html',
  styleUrl: './bottom-toolbar.component.scss',
})
export class BottomToolbarComponent {
  readonly shell = inject(ShellService);
  readonly userView = inject(UserViewService);
  readonly walletDialog = inject(WalletDialogService);
  readonly merchView = inject(MerchViewService);
  private readonly _auth = inject(AuthService);
  private readonly _merchDialog = inject(MerchDialogService);
  private readonly _promotionsView = inject(PromotionsView);
  private readonly _dialog = inject(DialogService);
  private readonly _appRouterService = inject(AppRouterService);

  user = toSignal(this.userView.state$);

  homeOpen = toSignal(
    this._appRouterService.route$.pipe(map((route) => route === '/'))
  );
  browseOpen = toSignal(
    this._appRouterService.route$.pipe(map((route) => route === '/games'))
  );
  promotionsOpen = toSignal(
    this._appRouterService.route$.pipe(map((route) => route === '/promotions'))
  );

  readonly promotionsCount = toSignal(this._promotionsView.promotionsCount$);

  readonly authReady = toSignal(this._auth.ready$);
  readonly authUser = toSignal(this._auth.user$);

  async goToShop() {
    this.shell.closeSidenavs();
    await this._merchDialog.openShop();
  }

  openAuthDialog(authView: 'login' | 'signup' = 'login') {
    this._dialog.open<AuthComponent, AuthDialogData>(AuthComponent, {
      id: DialogKey.Auth,
      data: { initialView: authView },
      disableClose: true,
    });
  }
}
